// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"articleBadge___wrapper___5qDAN"};